import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  description: string
}

export const ActionConfigurationHeader = ({ description }: Props) => {
  return (
    <Box gap="s8">
      <Text.Header2>
        {i18n.t('processes.process_settings.actions.config.steps.set_up')}
      </Text.Header2>
      <Text.Normal>{description}</Text.Normal>
    </Box>
  )
}
